import React from 'react';
import { DarkTheme as theme, MailIcon, Text } from '@redacted/react-components';
import { Box, Grid } from '@material-ui/core';

function SignupSuccess() {
  return (
    <Box width="75%" margin="0 auto">
      <Grid container direction="column" spacing={8}>
        <Grid item style={{ textAlign: 'center' }}>
          <MailIcon color={theme.palette.success.dark} size={69} />
        </Grid>
        <Grid item>
          <Text variant="h2" align="center" gutterBottom>Check your email</Text>
          <Text align="center">
            We&apos;ve sent you an email with a link to get started on the TIDE platform.
          </Text>
        </Grid>
      </Grid>
    </Box>
  );
}

export default SignupSuccess;
